module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar level = locals.level;\n%>\n<xml id="toolbox" style="display: none;">\n  <block type="maze_moveForward" id="moveForward"></block>\n  <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n  <block type="maze_turn"><title name="DIR">turnRight</title></block>\n  <block type="maze_dig" id="remove"></block>\n  <% if (level > 1) { -%>\n    <block type="maze_fill"></block>\n    <% if (level > 2) { -%>\n      <block type="controls_repeat">\n        <title name="TIMES">5</title>\n      </block>\n      <% if (level > 9) { -%>\n        <block type="karel_if"></block>\n      <% } -%>\n    <% } -%>\n    <% if (level === 5 || level === 10 || level === 11) { -%>\n      <block type="maze_untilBlocked"></block>\n    <% } -%>\n    <% if (level > 5 && level < 8) { -%>\n      <block type="maze_untilBlockedOrNotClear"></block>\n    <% } -%>\n    <% if (level === 8 || level === 9) { -%>\n      <block type="maze_untilBlockedOrNotClear">\n        <title name="DIR">isPathForward</title>\n      </block>\n    <% } -%>\n  <% } -%>\n</xml>\n', __filename = "src/maze/toolboxes/karel1.xml.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var level = locals.level;
        __line = 6;
        __append('\n<xml id="toolbox" style="display: none;">\n  <block type="maze_moveForward" id="moveForward"></block>\n  <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n  <block type="maze_turn"><title name="DIR">turnRight</title></block>\n  <block type="maze_dig" id="remove"></block>\n  ');
        __line = 12;
        if (level > 1) {
            __append('    <block type="maze_fill"></block>\n    ');
            __line = 14;
            if (level > 2) {
                __append('      <block type="controls_repeat">\n        <title name="TIMES">5</title>\n      </block>\n      ');
                __line = 18;
                if (level > 9) {
                    __append('        <block type="karel_if"></block>\n      ');
                    __line = 20;
                }
                __append("    ");
                __line = 21;
            }
            __append("    ");
            __line = 22;
            if (level === 5 || level === 10 || level === 11) {
                __append('      <block type="maze_untilBlocked"></block>\n    ');
                __line = 24;
            }
            __append("    ");
            __line = 25;
            if (level > 5 && level < 8) {
                __append('      <block type="maze_untilBlockedOrNotClear"></block>\n    ');
                __line = 27;
            }
            __append("    ");
            __line = 28;
            if (level === 8 || level === 9) {
                __append('      <block type="maze_untilBlockedOrNotClear">\n        <title name="DIR">isPathForward</title>\n      </block>\n    ');
                __line = 32;
            }
            __append("  ");
            __line = 33;
        }
        __append("</xml>\n");
        __line = 35;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}